/**
 * Where participants write to AfricaNenda for help. This is the only place the
 * address is set: every page that offers help reads it from here.
 */
export const SUPPORT_EMAIL = 'iipstraining@africanenda.org';
